import { YieldFetcher } from '../../types'

const WSTETH_URL = 'https://eth-api.lido.fi/v1/protocol/steth/apr/sma'
// Fallback: /chart/ returns full history but we only use the latest entry
const DEFILLAMA_LIDO_URL =
  'https://yields.llama.fi/chart/747c1d2a-c668-4682-b9f9-296708a3dd90'
const tETH = 'Treehouse ETH::TETH'

const robustFetchJson = async (
  url: string,
  { timeoutMs = 5000, attempts = 3 } = {},
): Promise<any> => {
  let lastErr: unknown
  for (let i = 0; i < attempts; i++) {
    try {
      const res = await fetch(url, {
        headers: {
          accept: 'application/json',
          'user-agent': '1delta-margin-fetcher',
        },
        signal: AbortSignal.timeout(timeoutMs),
      })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return await res.json()
    } catch (e) {
      lastErr = e
      if (i < attempts - 1) {
        await new Promise((r) => setTimeout(r, 250 * (i + 1)))
      }
    }
  }
  throw lastErr
}

async function fetchLidoApr(): Promise<number> {
  try {
    const res = await robustFetchJson(WSTETH_URL)
    return Number(res.data.aprs.at(-1).apr) * 0.9
  } catch {
    const res = await robustFetchJson(DEFILLAMA_LIDO_URL)
    const latest = res.data.at(-1)
    return Number(latest.apyBase) * 0.9
  }
}

export const wstethFetcher: YieldFetcher = {
  label: 'WSTETH',
  fetch: async () => {
    const apr = await fetchLidoApr()
    return {
      WSTETH: apr,
      [tETH]: apr,
    }
  },
}

export const stmaticFetcher: YieldFetcher = {
  label: 'STMATIC',
  fetch: async () => {
    // const res = await fetch('https://polygon.lido.fi/api/stats').then((r) => r.json())
    // return { STMATIC: Number(res.apr) * 0.9 }
    return { STMATIC: 0 }
  },
}
